<div dropdown container="body" placement="bottom right" class="btn-group" [isDisabled]="1 | isReadonlyRole">
  <button
    dropdownToggle
    type="button"
    class="btn btn-cst-warning text-uppercase dropdown-toggle"
    [ngClass]="{ 'circle-button': circleButton }"
  >
    <span class="fas fa-bolt"></span>

    <ng-container *ngIf="!circleButton"> Action <span class="caret"></span> </ng-container>
  </button>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
    <ng-content select="[pre-content]"></ng-content>

    <li *ngIf="(showOption | call: options:'guest':'pre-approve-guest') && (inquiry | canPreApprove)">
      <button (click)="onPreApprove()" type="button">Pre-approve guest</button>
    </li>
    <li *ngIf="(showOption | call: options:'guest':'deny-guest') && (inquiry | canDeny)">
      <button (click)="onDeny()" type="button">Deny guest</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'billing':'add-billing') && !!inquiry.booked && !inquiry.billing && !!payment"
      matTooltip="Add credit card details to this booking."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onAddBillingDetails()" type="button">
        <i class="fal fa-file-invoice-dollar"></i> Add billing details
      </button>
    </li>
    <li
      *ngIf="(showOption | call: options:'billing':'view-billing') && inquiry.billing && payment"
      matTooltip="View the credit card details associated with this booking."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onViewBillingDetails()" type="button">
        <i class="fal fa-file-invoice-dollar"></i> View billing details
      </button>
    </li>
    <li
      *ngIf="(showOption | call: options:'send-guest-portal-link') && inquiry.booked"
      matTooltip="Send a link to your guest portal for this booking."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onSendGuestLogin()" type="button"><i class="fal fa-link"></i> Send guest portal link</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'import') && isAirbnbBooking"
      matTooltip="Re-import this booking from Airbnb."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onImport()" type="button"><i class="fal fa-cloud-download"></i> Re-import</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-follow-up':'mark-for-follow-up') && !inquiry.followup"
      matTooltip="Flag this inquiry for follow-up later."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onFollowUp()" type="button"><i class="fas fa-star"></i> Mark for follow-up</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-follow-up':'mark-for-no-follow-up') && inquiry.followup"
      matTooltip="Remove follow-up flag from this inquiry."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onNoFollowUp()" type="button"><i class="fal fa-star"></i> Mark for no follow-up</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-paid':'mark-as-paid') && !inquiry.paid && !!inquiry.booked"
      matTooltip="Mark this booking as paid."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onPaid()" type="button"><i class="fal fa-money-check-alt"></i> Mark as paid</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-paid':'mark-as-unpaid') && inquiry.paid && !!inquiry.booked"
      matTooltip="Mark this booking as unpaid."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onUnPaid()" type="button"><i class="fal fa-money-check-alt"></i> Mark as unpaid</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-read':'mark-as-read') && !inquiry.read"
      matTooltip="Mark this message as read."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onRead()" type="button"><i class="fal fa-envelope-open"></i> Mark as read</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-read':'mark-as-unread') && inquiry.read"
      matTooltip="Mark this message as unread."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onUnRead()" type="button"><i class="fal fa-envelope"></i> Mark as unread</button>
    </li>
    <li
      *ngIf="
        (showOption | call: options:'toggle-checkinout':'mark-as-checkin') &&
        inquiry.checkInStatus === checkInStatus.Arriving &&
        !!inquiry.booked
      "
      matTooltip="Mark the status as checked in."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onCheckedIn()" type="button"><i class="fas fa-arrow-to-right"></i> Mark as checked in</button>
    </li>
    <li
      *ngIf="
        (showOption | call: options:'toggle-checkinout':'mark-as-checkout') &&
        inquiry.checkInStatus === checkInStatus.CheckedIn &&
        !!inquiry.booked
      "
      matTooltip="Mark the status as checked out."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onCheckedOut()" type="button"><i class="fas fa-arrow-from-left"></i> Mark as checked out</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-archive':'archive') && !inquiry.archived"
      matTooltip="Archive this inquiry and remove it from the default inbox view."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onArchive()" type="button"><i class="fal fa-archive"></i> Archive</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'toggle-archive':'unarchive') && inquiry.archived"
      matTooltip="Restore this inquiry from archive and return it to the inbox view."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onUnArchive()" type="button"><i class="fal fa-file-archive"></i> Unarchive</button>
    </li>
    <li
      *ngIf="(showOption | call: options:'unlink') && inquiry.links?.length"
      matTooltip="Unlink this inquiry from other related and previously linked inquiries."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onUnLink()" type="button"><i class="fal fa-unlink"></i> UnLink</button>
    </li>
    <li
      *ngIf="showOption | call: options:'manage-tags'"
      matTooltip="Click here to add tags to this booking. Tags can be used when filtering on various tables and reports, as well as conditions on certain triggers."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onManageTags()" type="button"><i class="fal fa-tags"></i> Manage Tags</button>
    </li>

    <li
      *ngIf="(showOption | call: options:'guest-portal') && inquiry.booked && (guestPortalDomain$ | async)"
      matTooltip=""
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onSetGuestPortalAccessible()" type="button">
        <i class="fal" [ngClass]="!inquiry.disableGuestPortal ? 'fa-user-times' : 'fa-user-check'"></i>
        {{ inquiry.disableGuestPortal ? 'Enable' : 'Disable' }} Guest Portal
      </button>
    </li>

    <li
      *ngIf="inquiry.booked && (showOption | call: options:'print')"
      matTooltip="Preview booking details and print this booking."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onPrint()" type="button"><i class="fal fa-print"></i> Print</button>
    </li>
    <li
      *ngIf="showOption | call: options:'copy'"
      matTooltip="Click here to clone this booking"
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onClone()" type="button"><i class="fal fa-copy"></i> Clone</button>
    </li>
    <li
      *ngIf="showOption | call: options:'delete'"
      matTooltip="Permanently remove this inquiry from Tokeet."
      matTooltipClass="text-center"
      matTooltipPosition="left"
    >
      <button (click)="onDelete()" type="button"><i class="fal fa-trash-alt"></i> Delete</button>
    </li>

    <ng-content select="[post-content]"></ng-content>
  </ul>
</div>
